export const modern = [
  {
    number: 'MBB100',
    hasModel: false,
  },
  {
    number: 'MBB101',
    hasModel: false,
  },
  {
    number: 'MBB102',
    hasModel: false,
  },
  {
    number: 'MBB103',
    hasModel: false,
  },
  {
    number: 'MBB104',
    hasModel: false,
  },
  {
    number: 'MBB105',
    hasModel: false,
  },
  {
    number: 'MBB106',
    hasModel: false,
  },
  {
    number: 'MBB107',
    hasModel: false,
  },
  {
    number: 'MBB108',
    hasModel: false,
  },
  {
    number: 'MBB109',
    hasModel: false,
  },
  {
    number: 'MBB110',
    hasModel: false,
  },
  {
    number: 'MBB111',
    hasModel: false,
  },
  {
    number: 'MBB112',
    hasModel: false,
  },
  {
    number: 'MBB113',
    hasModel: false,
  },
  {
    number: 'MBB114',
    hasModel: false,
  },
  {
    number: 'MBB115',
    hasModel: false,
  },
  {
    number: 'MBB116',
    hasModel: false,
  },
  {
    number: 'MBB117',
    hasModel: false,
  },
  {
    number: 'MBB118',
    hasModel: false,
  },
  {
    number: 'MBB119',
    hasModel: false,
  },
  {
    number: 'MBB120',
    hasModel: false,
  },
  {
    number: 'MBB121',
    hasModel: false,
  },
  {
    number: 'MBB122',
    hasModel: false,
  },
  {
    number: 'MBB123',
    hasModel: false,
  },
  {
    number: 'MBB124',
    hasModel: false,
  },
  {
    number: 'MBB125',
    hasModel: false,
  },
  {
    number: 'MBB126',
    hasModel: false,
  },
  {
    number: 'MBB127',
    hasModel: false,
  },
  {
    number: 'MBB128',
    hasModel: false,
  },
  {
    number: 'MBB129',
    hasModel: false,
  },
  {
    number: 'MBB130',
    hasModel: false,
  },
  {
    number: 'MBB131',
    hasModel: false,
  },
  {
    number: 'MBB132',
    hasModel: false,
  },
  {
    number: 'MBB133',
    hasModel: false,
  },
  {
    number: 'MBB134',
    hasModel: false,
  },
  {
    number: 'MBB135',
    hasModel: false,
  },
  {
    number: 'MBB136',
    hasModel: false,
  },
  {
    number: 'MBB137',
    hasModel: false,
  }
];
